export function Typography() {
  return {
    fontFamily: ['Gabarito', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  };
}
